import { render } from "./LangComponent.vue?vue&type=template&id=cd3c1e88"
import script from "./LangComponent.vue?vue&type=script&lang=js"
export * from "./LangComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__